import { render, staticRenderFns } from "./cadstone.vue?vue&type=template&id=4bd2a64f&scoped=true"
import script from "./cadstone.vue?vue&type=script&lang=js"
export * from "./cadstone.vue?vue&type=script&lang=js"
import style0 from "./cadstone.vue?vue&type=style&index=0&id=4bd2a64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd2a64f",
  null
  
)

export default component.exports